import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=931e1c70&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=931e1c70&prod&lang=css&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=931e1c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e1c70",
  null
  
)

export default component.exports